import { render, staticRenderFns } from "./head-nav.vue?vue&type=template&id=4e5d5c58&scoped=true&"
import script from "./head-nav.vue?vue&type=script&lang=js&"
export * from "./head-nav.vue?vue&type=script&lang=js&"
import style0 from "./head-nav.vue?vue&type=style&index=0&id=4e5d5c58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d5c58",
  null
  
)

export default component.exports